module.exports = __webpack_public_path__ + "img/image_010.3aae23fe.jpg";